<template>
  <tr>
    <td class="align-middle">
      <a href="#">{{ funder.title }}</a>
    </td>
    <td class="align-middle">{{ formatBudget(funder.budget) }}</td>
    <td class="text-left">
      <template v-if="funder.agreement_path">
        <a :download="funder.agreement" :href="`/${funder.agreement_path}`">{{ funder.agreement }}</a>
      </template>
      <template v-else>
        <a href="#"
           @click.prevent="$emit('add-agreement', funder)"
        ><i class="fas fa-paperclip"></i> Agregar convenio</a>
      </template>
    </td>
    <td class="align-middle text-right">
      <a href="#"
         @click.prevent="$emit('edit-funder', funder)"
         class="btn btn-sm btn-icon btn-secondary"
         v-if="!readonly && editable">
        <i class="fas fa-pencil-alt"></i>
        <span class="sr-only">Editar</span>
      </a>
      <a href="#"
         @click.prevent="$emit('remove-funder', funder)"
         class="btn btn-sm btn-icon btn-secondary"
         v-if="!readonly && editable">
        <i class="far fa-trash-alt"></i>
        <span class="sr-only">Eliminar</span>
      </a>
    </td>
  </tr>
</template>

<script>
  export default {
    name: 'FundersTableItem',
    props: {
      funder: {
        type: Object,
        required: true,
      },
      readonly: {
        type: Boolean,
        default: false,
      },
      editable: {
        type: Boolean,
        default: true,
      },
    },
    methods: {
      formatBudget (budget) {
        const formatter = new Intl.NumberFormat('es-MX', {
          style: 'currency',
          currency: 'MXN',
        })
        
        return formatter.format(budget)
      },
    },
  }
</script>

<style lang="scss" scoped>
.opacity-50 {
  opacity: .5;
}
</style>
